import classNames from "classnames";
import { get } from "lodash";
import { useState } from "react";
import { MdClose, MdHeadsetMic } from "react-icons/md";
import { useMutation } from "shared/hooks/useApi";
import { UPDATE_PROJECT } from "utils/api/graphql/mutations/projects";
import { PROJECT } from "utils/api/graphql/queries/projects";
import HelpIcon from "../../../../Assets/icons/help.svg";
import HelpModal from "./Modal";
import HelpContactModal from "./ModalContact";

function Help({ project, hideDetails }) {
  const [open, setOpen] = useState(false);
  const [bottomHelpOpen, setBottomHelpOpen] = useState(false);
  const [updateProject] = useMutation(UPDATE_PROJECT, {
    refetchQueries: [
      {
        query: PROJECT,
        awaitRefetchQueries: true,
        variables: { where: { id: project?.id } },
      },
    ],
  });

  const onSubmit = (data) => {
    updateProject({
      variables: {
        where: { id: project?.id },
        data,
      },
    });
  };

  const onClose = () => {
    setOpen(false);
    setBottomHelpOpen(false);
  };
  const onOpen = () => {
    setOpen(true);
    setBottomHelpOpen(true);
  };

  const MODAL = {
    [true]: (
      <HelpContactModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
      />
    ),
    [false]: (
      <HelpModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        project={project}
      />
    ),
  };

  return (
    <>
      <div className="miltis-navbar__phone--mobile" onClick={onOpen}>
        <MdHeadsetMic className="miltis-navbar__phone-icon" />
      </div>
      <div className="miltis-navbar__phone" onClick={onOpen}>
        <MdHeadsetMic className="miltis-navbar__phone-icon" />
        {!hideDetails && (
          <div className="miltis-navbar__phone-group">
            <div className="miltis-navbar__phone-item">
              <span className="miltis-navbar__phone-label">
                Pour la métropole
              </span>
              <span className="miltis-navbar__phone-number">
                04 27 85 27 88
              </span>
            </div>
            <div className="miltis-navbar__phone-divider" />
            <div className="miltis-navbar__phone-item">
              <span className="miltis-navbar__phone-label">Pour les DROM</span>
              <span className="miltis-navbar__phone-number">
                05 96 75 71 75
              </span>
            </div>
          </div>
        )}
      </div>

      <button
        className={classNames("miltis-help-button", {
          "miltis-help-button--closed": !bottomHelpOpen,
        })}
        onClick={onOpen}
      >
        <div className="miltis-help-button__icon-wrapper">
          <img src={HelpIcon} alt="Help" className="miltis-help-button__icon" />
          {bottomHelpOpen && (
            <div
              className="miltis-help-button__close"
              onClick={(e) => {
                e.stopPropagation();
                setBottomHelpOpen(false);
              }}
            >
              <MdClose size={14} />
            </div>
          )}
        </div>
        <p className="miltis-help-button__text">Besoin d'aide ?</p>
      </button>
      {MODAL[!!get(project, "contact.user.firstname")]}
    </>
  );
}

export default Help;
